const MediaIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="24"
        height="24"
        rx="2"
        fill="var(--primary)"
        fillOpacity="0.1"
      />
      <path
        d="M16.9498 16.9498C15.6276 18.2719 13.8698 19 12 19C10.1302 19 8.37239 18.2719 7.05023 16.9498C5.72814 15.6276 5 13.8698 5 12C5 10.1302 5.72814 8.37239 7.05023 7.05023C8.37239 5.72814 10.1302 5 12 5C13.28 5 14.5325 5.34885 15.622 6.00879C15.8803 6.16531 15.9629 6.50158 15.8064 6.7599C15.6499 7.01827 15.3136 7.10079 15.0553 6.9443C14.1368 6.38786 13.0802 6.09375 12 6.09375C8.74328 6.09375 6.09375 8.74328 6.09375 12C6.09375 15.2567 8.74328 17.9062 12 17.9062C15.2567 17.9062 17.9062 15.2567 17.9062 12C17.9062 10.8355 17.5599 9.70192 16.9048 8.72192C16.7369 8.47085 16.8044 8.13122 17.0554 7.96335C17.3065 7.79543 17.6462 7.86295 17.814 8.11402C18.5899 9.27454 19 10.6183 19 12C19 13.8698 18.2719 15.6276 16.9498 16.9498Z"
        fill="var(--primary)"
      />
      <path
        d="M11.4162 14.8592C11.031 15.0827 10.5707 15.0834 10.1849 14.8612C9.7976 14.6382 9.56641 14.2378 9.56641 13.7902V10.2091C9.56641 9.76146 9.7976 9.36107 10.1849 9.13808C10.3772 9.02728 10.588 8.97194 10.7988 8.97194C11.0109 8.97194 11.2231 9.02805 11.4162 9.14013L14.5019 10.9306C14.8869 11.1541 15.1168 11.5537 15.1168 11.9997C15.1168 12.4456 14.8869 12.8452 14.5019 13.0687L11.4162 14.8592ZM13.9529 11.8767L10.8673 10.0862C10.8109 10.0534 10.7619 10.068 10.7307 10.0859C10.6985 10.1044 10.6602 10.1409 10.6602 10.2091V13.7902C10.6602 13.8584 10.6985 13.8949 10.7307 13.9134C10.7484 13.9236 10.7717 13.9326 10.799 13.9326C10.8198 13.9326 10.8428 13.9273 10.8673 13.9131L13.9529 12.1226C14.0109 12.089 14.023 12.0372 14.023 11.9997C14.023 11.9621 14.0109 11.9103 13.9529 11.8767Z"
        fill="var(--primary)"
      />
    </svg>
  );
};
export default MediaIcon;
